import _ from 'underscore';
import ko from 'knockout';

export default class ViewModel {
  constructor({
    data,
    i18n,
  }) {
    const campaignSettingData = _.findWhere(data.CreationFragments, { Type: 'Campaign' });
    const adGroupSettingData = _.findWhere(data.CreationFragments, { Type: 'Ad Group' });
    const adSettingData = _.findWhere(data.CreationFragments, { Type: 'Dynamic Search Ad' });

    this.model = {
      // campaign
      Name: campaignSettingData.Campaign,
      campaignType: 'dynamicSearch',
      isMixedDSACampaignRecommendation: true,
      CampaignSettings: [
        {
          DomainName: campaignSettingData.Website,
          Language: campaignSettingData.WebsiteLanguage,
        },
      ],
      Budget: {
        Amount: Math.round(Number(campaignSettingData.Budget) * 100) / 100,
        Id: '',
        Name: '',
      },
      context: {
        get: () => {},
      },
      // adgroup
      CampaignType: 'dynamicSearch',
      SearchBid: Math.round(Number(adGroupSettingData.SearchBid) * 100) / 100,
      AdGroupName: ko.observable(adGroupSettingData.AdGroup),
      // ads
      FinalUrls: [
        '',
      ],
      DisplayUrl: ko.observable(campaignSettingData.Website),
      Path1: '',
      Path2: '',
      Text: adSettingData.Text,
      TextPart2: adSettingData.Text2,
      isOppotunityCampaignLevel: !_.isNull(data.Target.CampaignId),
    };

    const maxAdgroupNameLength = 256;

    this.model.AdGroupName.error = ko.observable('');

    this.model.AdGroupName.isValid = () => {
      this.model.AdGroupName.error('');
      if (this.model.AdGroupName().length === 0) {
        this.model.AdGroupName.error(i18n.getString('InsertionOrderFilter_Filter_Validation_Common_Required')
                                     || 'Required field');
      }
      if (this.model.AdGroupName().length > maxAdgroupNameLength) {
        this.model.AdGroupName.error(i18n.getString('Validation_String_Max_Length', { maxlength: maxAdgroupNameLength })
                                     || `Field should not exceed ${maxAdgroupNameLength} characters`);
      }

      if (this.model.AdGroupName.error().length) {
        return false;
      }
      return true;
    };

    this.model.AdGroupName.char_rem = ko.computed(() => {
      const remainChar = maxAdgroupNameLength - this.model.AdGroupName().length;

      if (remainChar < 0) {
        return i18n.getString('ExceededCharactersText_New', { count: Math.abs(remainChar) })
               || `Exceeded by ${Math.abs(remainChar)} characters`;
      }
      return i18n.getString('RemainingCharactersText_New', { count: remainChar })
             || `${remainChar} characters remaining`;
    }, this);
  }
}
